import { useState, useEffect } from "react";

const CONFIG_URL = "https://zola.technology/api/company/messaging-config";

const useMessagingConfig = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("token");

  const fetchConfig = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${CONFIG_URL}/get/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch messaging config");
      }

      const data = await response.json();
      setConfig(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const updateConfig = async (newConfig) => {
    try {
      const response = await fetch(`${CONFIG_URL}/update/`, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newConfig),
      });

      if (!response.ok) {
        throw new Error("Failed to update messaging config");
      }

      const updatedData = await response.json();
      setConfig(updatedData);
      return { success: true, data: updatedData };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    }
  };

  useEffect(() => {
    fetchConfig();
  }, []);

  return { config, loading, error, updateConfig };
};

export default useMessagingConfig;
